import { USA_STATES_LIST } from '@Types/consts';

export const getStateDropdownItem = (state?: string) => {
  if (!state) return null;
  const stateData = USA_STATES_LIST.find((item) => item.value === state);
  if (!stateData) return null;

  return {
    title: stateData.title,
    value: stateData.value,
  };
};

export const getInitialState = (state: string) => {
  const stateData = USA_STATES_LIST.find((item) => item.value === state);
  return {
    title: stateData?.title || '',
    value: stateData?.value || '',
  };
};
